/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/unbound-method */
import React from 'react';
import { debounce, isEmpty, includes, filter, get } from 'lodash';
import { BTTStaff, SearchType } from 'types/campaign';
import { DateString } from 'types/string';
import { bttSpecialistSearch } from 'utils/api/campaign';
import { noSubmit } from 'utils/helpers';
import Spinner from 'components/common/next/spinner';

import './bttStaffSelect.scss';

interface Props {
  noResultsText?: string;
  onSelect(staff: BTTStaff): void;
  closeSearchOnSelect?: boolean;
  placeholder?: string;
}

interface State {
  search: string;
  searchResults: BTTStaff[];
  resultsOpen: boolean;
  loading: boolean;
}

class BttStaffSelect extends React.Component<Props, State> {
  public containerNode: HTMLDivElement | null = null;
  public searchField: HTMLInputElement | null = null;

  constructor(props: Props) {
    super(props);
    this.state = {
      search: '',
      searchResults: [],
      resultsOpen: false,
      loading: false,
    };
    this.searchStaff = debounce(this.searchStaff.bind(this), 300);
    this.changeSearch = this.changeSearch.bind(this);
    this.openSearch = this.openSearch.bind(this);
    this.closeSearch = this.closeSearch.bind(this);
  }

  componentDidMount() {
    // Fetch all staff immediately when the control is rendered
    this.setState({ loading: true });
    bttSpecialistSearch()
      .then((allStaff: BTTStaff[]) => {
        this.setState({ searchResults: allStaff || [], loading: false });
      })
      .catch(() => {
        this.setState({ searchResults: [], loading: false });
      });
  }

  async searchStaff(query: string) {
    if (!query || query.length < 1) {
      this.setState({ searchResults: [], loading: false });
      return;
    }
    this.setState({ loading: true });
    try {
      const allStaff = await bttSpecialistSearch();
      const filtered = (allStaff || []).filter((staff: BTTStaff) => {
        const name = (staff.name || '').toLowerCase();
        const title = (staff.title || '').toLowerCase();
        const email = (staff.email || '').toLowerCase();
        return (
          name.includes(query.toLowerCase()) ||
          title.includes(query.toLowerCase()) ||
          email.includes(query.toLowerCase())
        );
      });
      this.setState({ searchResults: filtered, loading: false });
    } catch {
      this.setState({ searchResults: [], loading: false });
    }
  }

  changeSearch(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.currentTarget.value;
    this.setState({ search: value, resultsOpen: true });
    this.searchStaff(value);
  }

  openSearch() {
    this.setState({ resultsOpen: true });
  }

  closeSearch() {
    this.setState({ resultsOpen: false });
  }

  select(staff: BTTStaff, closeSearch?: boolean) {
    const { onSelect, closeSearchOnSelect } = this.props;
    onSelect(staff);
    if (closeSearchOnSelect || closeSearch) {
      this.closeSearch();
      this.setState({ search: staff.name || '' });
    }
  }

  render() {
    const { placeholder, noResultsText } = this.props;
    const { search, searchResults, resultsOpen, loading } = this.state;

    // const showResults = !loading;

    const resultItem = (staff: BTTStaff) => {
      const { title, name, email, imageUrl, imageName } = staff;
      return (
        <div className="search-result staff-item" key={name} onClick={() => this.select(staff, true)} tabIndex={0}>
          <div className="image-container">
            {imageUrl ? (
              <img src={imageUrl} alt={imageName || name} style={{ width: 50, height: 50, objectFit: 'cover' }} />
            ) : (
              <div style={{ width: 50, height: 50, background: '#eee' }} />
            )}
          </div>
          <div className="item-details">
            <div className="title">{title}</div>
            <div className="label">
              <span className="emph">Nimi</span> {name}
            </div>
            <div className="label">
              <span className="emph">Sähköposti</span> {email}
            </div>
          </div>
        </div>
      );
    };

    return (
      <div className="staff-select" ref={(e) => (this.containerNode = e)}>
        <div className="staff-search-field form-control">
          <label>Valitse asiantuntija</label>
          <select
            value={search}
            onChange={(e) => {
              const selectedName = e.target.value;
              const selectedStaff = searchResults.find((staff) => staff.name === selectedName);
              if (selectedStaff) {
                this.select(selectedStaff, true);
              }
              this.setState({ search: selectedName });
            }}
            disabled={loading}
          >
            <option value="">-- Valitse asiantuntija --</option>
            {searchResults.map((staff, idx) => (
              <option key={`staff-opt-${idx}`} value={staff.name || ''}>
                {staff.name || ''}
              </option>
            ))}
          </select>
          {loading && (
            <div className="loading-results">
              <Spinner />
            </div>
          )}
          {!loading && searchResults.length === 0 && (
            <div className="no-results">{noResultsText || 'Ei hakutuloksia.'}</div>
          )}
        </div>
      </div>
    );
  }
}

export default BttStaffSelect;
